export const documents = [
  {
    title: "Employee Contract",
    date: "Jan 15, 2014"
  },
  {
    title: "NDA Agreement",
    date: "Jan 15, 2014"
  },
  {
    title: "Benefits Summary",
    date: "Jan 2025"
  },
  {
    title: "Tax Forms (W-2)",
    date: "Jan 2025"
  },
];
